// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_cz","cityChooser__text":"c-j_cA","cityChooser__placeholder":"c-j_cB","cityChooser__buttonIcon":"c-j_cC"};